"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColorDark = exports.getRGBOpacity = exports.normaliseColor = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Choose the right color to use for the dark or light variant of the theme
 * @param {object} color
 * @param {object} theme
 */


var normaliseColor = function normaliseColor(color, theme) {
  // use the provided color from the theme
  // otherwise, assume it's a color object passed it
  var colorObject = color;
  var result;

  if (colorObject) {
    if (theme.dark && colorObject.withDarkBg) {
      result = colorObject.withDarkBg;
    } else if (!theme.dark && colorObject.withLightBg) {
      result = colorObject.withLightBg;
    } else {
      // if colorObject is a just a hex string, just return that value
      result = colorObject;
    }
  }

  return result || 'inherit';
};

exports.normaliseColor = normaliseColor;

var parseHexToRGB = function parseHexToRGB(color) {
  return color.length === 4 ? color.match(/[A-Za-z0-9]{1}/g).map(function (colorVal) {
    return parseInt(colorVal, 16);
  }) : color.match(/[A-Za-z0-9]{2}/g).map(function (colorVal) {
    return parseInt(colorVal, 16);
  });
};

var getRGBArray = function getRGBArray(color) {
  if (/^#/.test(color)) {
    return parseHexToRGB(color);
  }

  if (/^rgb/.test(color)) {
    return color.match(/rgba?\((\s?[0-9]*\s?),(\s?[0-9]*\s?),(\s?[0-9]*\s?).*?\)/).splice(1);
  }

  return color;
};
/**
 * Applies an opacity to a hex color
 * @param {string} color
 * @param {decimal} opacity
 */


var getRGBOpacity = function getRGBOpacity(color, opacity) {
  var _getRGBArray = getRGBArray(color),
      _getRGBArray2 = _slicedToArray(_getRGBArray, 3),
      red = _getRGBArray2[0],
      green = _getRGBArray2[1],
      blue = _getRGBArray2[2];

  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(opacity, ")");
};
/**
 * Calculates whether the passed in color is light or dark
 * This calculator is useful if we want to adjust our elements automatically
 * depending on the container's background.
 * @param {string} color
 */


exports.getRGBOpacity = getRGBOpacity;

var isColorDark = function isColorDark(color) {
  var _getRGBArray3 = getRGBArray(color),
      _getRGBArray4 = _slicedToArray(_getRGBArray3, 3),
      red = _getRGBArray4[0],
      green = _getRGBArray4[1],
      blue = _getRGBArray4[2]; // http://www.had2know.com/technology/
  //  color-contrast-calculator-web-design.html


  var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
  return brightness < 125;
};

exports.isColorDark = isColorDark;